import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { AccordionPluginControl } from "../controls/accordion-plugin.js";
export const AccordionPlugin = ({
  editor
}) => {
  editor.ui.registry.addMenuItem('InsertAccordion' /*name of the plugin*/, {
    text: 'Accordion',
    icon: 'accordion',
    onAction() {
      const dialogContainer = document.createElement('div');
      document.body.appendChild(dialogContainer);
      const closeDialog = () => {
        unmountComponentAtNode(dialogContainer);
        dialogContainer.remove();
      };
      const dialog = /*#__PURE__*/React.createElement(AccordionPluginControl, {
        editor: editor,
        closeDialog: closeDialog
      });
      render(dialog, dialogContainer);
    }
  });
};
//# sourceMappingURL=AccordionPlugin.js.map